import { DockerNetwork } from '../../types';

import { MacvlanFormValues } from './types';

export function defaultMacvlanFormValues(): MacvlanFormValues {
  return {
    scope: 'local',
    parentNetworkCard: '',
    selectedNetworkConfig: null,
    selectedNodes: [],
  };
}

type NetworkConfig = {
  Internal: boolean | null;
  Attachable: boolean | null;
  ConfigOnly?: boolean;
  Options: Record<string, string>;
  ConfigFrom?: { Network: string };
  Scope?: string;
};

/** Returns a new networkConfig for macvlan local (config-only) scope */
export function applyMacvlanConfigOnly(
  networkConfig: NetworkConfig,
  values: MacvlanFormValues
): NetworkConfig {
  return {
    ...networkConfig,
    Internal: null,
    Attachable: null,
    ConfigOnly: true,
    Options: { ...networkConfig.Options, parent: values.parentNetworkCard },
  };
}

/** Returns a new networkConfig for macvlan swarm (config-from) scope */
export function applyMacvlanConfigFrom(
  networkConfig: NetworkConfig,
  selectedNetwork: DockerNetwork,
  isSwarmMode: boolean
): NetworkConfig {
  return {
    ...networkConfig,
    ConfigFrom: { Network: selectedNetwork.Name },
    Scope: isSwarmMode ? 'swarm' : 'local',
  };
}
